import { VdDropdown, VdDropdownItem, VdButton, VdFormField, VdForm, VdInput } from "@voodoo.io/voodoo-ui";
import { App as VueApplication } from "vue";

import CustomIcon from "@/components/structure/CustomIcon/CustomIcon.vue";
import ABTestsIcon from "@/components/structure/icons/ABTestsIcon.vue";
import ActionLogsIcon from "@/components/structure/icons/ActionLogsIcon.vue";
import AudiencesIcon from "@/components/structure/icons/AudiencesIcon.vue";
import BackArrowIcon from "@/components/structure/icons/BackArrowIcon.vue";
import BigCheckIcon from "@/components/structure/icons/BigCheckIcon.vue";
import BugIcon from "@/components/structure/icons/BugIcon.vue";
import BurgerMenuIcon from "@/components/structure/icons/BurgerMenuIcon.vue";
import CalendarIcon from "@/components/structure/icons/CalendarIcon.vue";
import CheckIcon from "@/components/structure/icons/CheckIcon.vue";
import ClassesIcon from "@/components/structure/icons/ClassesIcon.vue";
import CloseIcon from "@/components/structure/icons/CloseIcon.vue";
import ComputerIcon from "@/components/structure/icons/ComputerIcon.vue";
import ConfigurationIcon from "@/components/structure/icons/ConfigurationIcon.vue";
import CreateIcon from "@/components/structure/icons/CreateIcon.vue";
import DeleteIcon from "@/components/structure/icons/DeleteIcon.vue";
import DropdownIcon from "@/components/structure/icons/DropdownIcon.vue";
import EditIcon from "@/components/structure/icons/EditIcon.vue";
import FeaturesIcon from "@/components/structure/icons/FeaturesIcon.vue";
import HandleIcon from "@/components/structure/icons/HandleIcon.vue";
import HomeIcon from "@/components/structure/icons/HomeIcon.vue";
import IAPManagerIcon from "@/components/structure/icons/IAPManagerIcon.vue";
import ImportIcon from "@/components/structure/icons/ImportIcon.vue";
import InfoIcon from "@/components/structure/icons/InfoIcon.vue";
import LiveIcon from "@/components/structure/icons/LiveIcon.vue";
import LiveOpsIcon from "@/components/structure/icons/LiveOpsIcon.vue";
import LockIcon from "@/components/structure/icons/LockIcon.vue";
import MultipleUsersIcon from "@/components/structure/icons/MultipleUsersIcon.vue";
import NextArrowIcon from "@/components/structure/icons/NextArrowIcon.vue";
import NotificationHeaderIcon from "@/components/structure/icons/NotificationHeaderIcon.vue";
import NotificationMenuIcon from "@/components/structure/icons/NotificationMenuIcon.vue";
import OptionsIcon from "@/components/structure/icons/OptionsIcon.vue";
import PendingIcon from "@/components/structure/icons/PendingIcon.vue";
import PhoneIcon from "@/components/structure/icons/PhoneIcon.vue";
import ThePlaceholderIcon from "@/components/structure/icons/PlaceholderIcon.vue";
import ProfileHeaderIcon from "@/components/structure/icons/ProfileHeaderIcon.vue";
import PublishIcon from "@/components/structure/icons/PublishIcon.vue";
import QuestionMarkIcon from "@/components/structure/icons/QuestionMarkIcon.vue";
import SandboxIcon from "@/components/structure/icons/SandboxIcon.vue";
import SearchIcon from "@/components/structure/icons/SearchIcon.vue";
import TargetIcon from "@/components/structure/icons/TargetIcon.vue";
import TestersIcon from "@/components/structure/icons/TestersIcon.vue";
import TimerIcon from "@/components/structure/icons/TimerIcon.vue";
import TrafficPlotIcon from "@/components/structure/icons/TrafficPlotIcon.vue";
import UserIcon from "@/components/structure/icons/UserIcon.vue";
import VDDialog from "@/components/structure/VDDialog/VDDialog.vue";
import VDDistributionBar from "@/components/structure/VDDistributionBar/VDDistributionBar.vue";
import VDEmpty from "@/components/structure/VDEmpty/VDEmpty.vue";
import VDError from "@/components/structure/VDError/VDError.vue";
import VDPageDialog from "@/components/structure/VDPageDialog/VDPageDialog.vue";
import VDPageForm from "@/components/structure/VDPageForm/VDPageForm.vue";

export default (vueInstance: VueApplication) => {
  vueInstance.component("VdPageDialog", VDPageDialog);
  vueInstance.component("VdDialog", VDDialog);
  vueInstance.component("VdDropdown", VdDropdown);
  vueInstance.component("VdDropdownItem", VdDropdownItem);
  vueInstance.component("VdCustomIcon", CustomIcon);
  vueInstance.component("VdPageForm", VDPageForm);
  vueInstance.component("VdButton", VdButton);
  vueInstance.component("VdInput", VdInput);
  vueInstance.component("VdForm", VdForm);
  vueInstance.component("VdFormField", VdFormField);
  vueInstance.component("VdEmpty", VDEmpty);
  vueInstance.component("VdDistributionBar", VDDistributionBar);
  vueInstance.component("VdError", VDError);

  /**
   * Icons
   */
  vueInstance.component("TrafficPlotIcon", TrafficPlotIcon);
  vueInstance.component("LiveIcon", LiveIcon);
  vueInstance.component("LockIcon", LockIcon);
  vueInstance.component("PublishedIcon", LiveIcon);
  vueInstance.component("PendingIcon", PendingIcon);
  vueInstance.component("BackArrowIcon", BackArrowIcon);
  vueInstance.component("BugIcon", BugIcon);
  vueInstance.component("BurgerMenuIcon", BurgerMenuIcon);
  vueInstance.component("PlaceholderIcon", ThePlaceholderIcon);
  vueInstance.component("AbTestsIcon", ABTestsIcon);
  vueInstance.component("HomeIcon", HomeIcon);
  vueInstance.component("AudiencesIcon", AudiencesIcon);
  vueInstance.component("BigCheckIcon", BigCheckIcon);
  vueInstance.component("CalendarIcon", CalendarIcon);
  vueInstance.component("CheckIcon", CheckIcon);
  vueInstance.component("ClassesIcon", ClassesIcon);
  vueInstance.component("CloseIcon", CloseIcon);
  vueInstance.component("ConfigurationIcon", ConfigurationIcon);
  vueInstance.component("CreateIcon", CreateIcon);
  vueInstance.component("DeleteIcon", DeleteIcon);
  vueInstance.component("DropdownIcon", DropdownIcon);
  vueInstance.component("EditIcon", EditIcon);
  vueInstance.component("FeaturesIcon", FeaturesIcon);
  vueInstance.component("HandleIcon", HandleIcon);
  vueInstance.component("IapManagerIcon", IAPManagerIcon);
  vueInstance.component("ImportIcon", ImportIcon);
  vueInstance.component("InfoIcon", InfoIcon);
  vueInstance.component("LiveOpsIcon", LiveOpsIcon);
  vueInstance.component("NextArrowIcon", NextArrowIcon);
  vueInstance.component("NotificationHeaderIcon", NotificationHeaderIcon);
  vueInstance.component("NotificationMenuIcon", NotificationMenuIcon);
  vueInstance.component("OptionsIcon", OptionsIcon);
  vueInstance.component("PhoneIcon", PhoneIcon);
  vueInstance.component("ActionLogsIcon", ActionLogsIcon);
  vueInstance.component("ProfileHeaderIcon", ProfileHeaderIcon);
  vueInstance.component("PublishIcon", PublishIcon);
  vueInstance.component("QuestionMarkIcon", QuestionMarkIcon);
  vueInstance.component("SearchIcon", SearchIcon);
  vueInstance.component("TargetIcon", TargetIcon);
  vueInstance.component("SandboxIcon", SandboxIcon);
  vueInstance.component("TestersIcon", TestersIcon);
  vueInstance.component("TimerIcon", TimerIcon);
  vueInstance.component("UserIcon", UserIcon);
  vueInstance.component("MultipleUsersIcon", MultipleUsersIcon);
  vueInstance.component("ComputerIcon", ComputerIcon);
};
